const STAFF_FETCH_SERVICE_TYPES = 'staff_fetch_service_types';
const STAFF_FETCH_ORDER_SERVICE_TYPES = 'staff_fetch_order_service_types';
const STAFF_FETCH_SERVICE_TYPE = 'staff_fetch_service_type';
const STAFF_DELETE_SERVICE_TYPE = 'staff_delete_service_type';
const STAFF_PERSIST_SERVICE_TYPE = 'staff_persist_service_type';

export default {
    STAFF_FETCH_SERVICE_TYPES,
    STAFF_FETCH_ORDER_SERVICE_TYPES,
    STAFF_FETCH_SERVICE_TYPE,
    STAFF_DELETE_SERVICE_TYPE,
    STAFF_PERSIST_SERVICE_TYPE,
};
